/* This page is for Approval and Display page */

import React, { useState, useEffect, useRef } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Redux
import { useDispatch, useSelector } from "react-redux";

//Serivce
import ItemServiceCustomer from "../../../../services/customer_appCommonService";
import CustomerItemService from "../../../../services/customer_v2_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import DataTable from "react-data-table-component";
import ShowHorizontalStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowHorizontalStatus";
import Loader from "../../../../Components/Loader";
import { formatDateTime } from "../../../../common/Validations";
import WorkflowApproveReject from "../../../../Components/Workflow/WorkflowApproveReject";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import CompareLineItemTable from "./CompareLineItemTable";
import {
  addPurchaseOrder,
  quotationListInfo,
} from "../../../../redux/feature/customer_app/customerSlice";
import CustomerConstants from "../../../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import PrintCommercialEvaluation from "./PrintCommercialEvaluation";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";

const CommercialEvaluation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "Sourcing");
  localStorage.setItem("submenu", "Request for Quotation");

  let rfxNr = useSelector((state) => state?.customer?.rfq?.rfxNr); // User Details from Store
  let workflowConfig = useSelector((state) => state?.common?.data?.workflow); // workflowConfig Details from Store
  let workflow = useSelector((state) => state?.customer?.rfq?.workflowTECH); // workflowTECH from Store

  const [loading, setLoading] = useState(true);
  const [lineItemData, setLineItemData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [itemTableData, setItemTableData] = useState([]);
  const [getDisabledStatus, setDisabledStatus] = useState(false);

  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible9, setCardVisible9] = useState(true);

  const [formInputs, setFormInputs] = useState({
    buyerConact: "",

    rfxType: "",
    productType: "",
    rfxValue: "",
    rfxHeaderStatus: "",
    rfxbidType: "",
    rfxNoOfEvaluationType: "",
    rfxCurrency: "",
    rfxTechFocalPersonId: "",
    technicalApprovalType: "",
    plant: "",
    buyerResponsible: "",
    companyAddress: "",
    buyerEmail: "",
    initiatorName: "",
    initiator: "",
    billingAddressCodeDesc: "",
    createdOn: "",

    deliveryAddressCodeDesc: "",
    rfxCategoryType: "",
    rfxCategoryCode: "",
    rfxCategoryDesc: "",
    rfqCreation: "",
    rfxTitle: "",
    openingdate: "",
    openingtime: "",
    closingdate: "",
    closingtime: "",
    rfxDescription: "",
    typeOfPurchase: "",
    otherCurrencies: "",
    headerIncoTerms: "",
    procurementStrategies: "",
    items: "",
    formCOMM: "",
    formTECH: "",
    termsConditions: [],
    supplierList: [],

    openingDateTime: "",
    closingDateTime: "",
    totalHour: "",
    techEvaluationStartedOn: "",
    techEvaluationPreparedOn: "",
    technicalEvaluator: "",
  });

  const createPO = (quotationNr, qtnVersion) => {
    let obj = {
      quotationNr,
      qtnVersion,
    };
    dispatch(quotationListInfo(obj)); // Store both values in Redux
    navigate(CustomerConstants.CUSTOMER_V2_PURCHASE_ORDER_CREATION); // Navigate to detail page
  };

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility9 = () => {
    setCardVisible9(!isCardVisible9);
  };
  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  const detailedPage = (quotationNr, qtnVersion) => {
    let obj = {
      quotationNr,
      qtnVersion,
    };
    dispatch(quotationListInfo(obj)); // Store both values in Redux
    navigate(CustomerConstants.CUSTOMER_V2_QUOTATION_DETAILS); // Navigate to detail page
  };

  const detailedPagePO = (poNumber) => {
    dispatch(addPurchaseOrder(poNumber));
    navigate(CustomerConstants.CUSTOMER_V2_PURCHASE_ORDER_DETAILS);
  };

  // send print data
  const [printCommercialEvalData, setprintCommercialEvalData] = useState();

  const suppliersColumns = [
    {
      name: "Supplier ID",
      selector: (row) => row.userId || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
        // onClick={() => detailedPage(row.userId)}
        >
          {row.userId || "-"}{" "}
        </button>
      ),
      width: "120px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.status} />
        </>
      ),
      width: "170px",
    },
    {
      name: "Supplier",
      selector: (row) => row.organisationName,
      cell: (row) => (
        <>
          <span class="bg-table-status bg-table-new-status">
            {row.organisationName}
          </span>
        </>
      ),
      sortable: true,
      width: "250px",
    },
    {
      name: "Quotation Number",
      cell: (row) => (
        <>
          {row.qtnSupplierStatus === "QTN Received" ? (
            <button
              className="btnInfo"
              onClick={() => detailedPage(row.quotationNr, row.qtnVersion)}
            >
              {row.quotationNr}
            </button>
          ) : (
            "--"
          )}
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Qtn Status",
      selector: (row) => row.qtnSupplierStatus || "--",
      cell: (row) => (
        <>
          <TableStatusField status={row.qtnSupplierStatus} />
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Qtn Date",
      selector: (row) => formatDateTime(row?.quotationCreatedAt) || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Others Charges",
      selector: (row) => row?.qtnTotal,
      cell: (row) => (
        <>
          {row?.qtnSubTotalOtherCharges ? (
            <>
              <span className="fw-bold">{row.qtnSubTotalOtherCharges}</span>
              &nbsp;INR
            </>
          ) : (
            "-- INR"
          )}
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Qtn Value",
      selector: (row) => row?.qtnTotal,
      cell: (row) => (
        <>
          {row?.qtnTotal ? (
            <>
              <span className="fw-bold">{row.qtnTotal}</span>
              &nbsp;INR
            </>
          ) : (
            "-- INR"
          )}
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: formInputs.rfxHeaderStatus === "PO Created" ? "PO Number" : "Create PO",
      selector: (row) => row.purchasingDocumentNr || "--",
      sortable: true,
      cell: (row) => {
        const poNumber = row?.purchasingDocumentNr;
        if (formInputs.rfxHeaderStatus === "PO Created") {
          return poNumber ? (
            <button className="btnInfo" onClick={() => detailedPagePO(poNumber)}>
              {poNumber}
            </button>
          ) : (
            "--"
          );
        } else {
          return (
            <button
              className="btnInfo"
              onClick={() => createPO(row.quotationNr, row.qtnVersion)}
            >
              <i className="bi bi-plus-lg"></i> Create
            </button>
          );
        }
      },
      width: "180px",
    },
  ];
  // From Child Component
  const handleItemData = (data) => {
    setItemTableData(data);
    setFormInputs((formInputs) => ({
      ...formInputs,
      items: data,
    }));
  };

  const loadInitialPageData = async () => {
    if (rfxNr) {
      let obj = {
        documentNumber: rfxNr,
      };
      await CustomerItemService.getRfxDetail(obj).then((item) => {
        if (item?.status === 200) {
          setFormInputs((prev) => ({ ...prev, ...item?.data[0] }));
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
      });
      setLoading(false);
    } else {
      window.history.back();
    }
  };

  // Load data
  const loadCommercialEvaluationData = async () => {
    if (rfxNr) {
      let obj = {
        // queryName: "ShowRFXCommEvaluation",
        queryName: "CompareRFXQuotations",
        rfxNr: rfxNr,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await ItemServiceCustomer.generateCustomerQuery(obj).then((item) => {
        if (item?.status === 200) {
          setFormInputs((prev) => ({ ...prev, ...item?.data[0] }));
          if (item?.data[0]?.rfxHeaderStatus === "Tech Approved") {
            setDisabledStatus(false);
          } else {
            setDisabledStatus(false);
          }

          setTimeout(() => {
            setLineItemData(item?.data);
          }, 500);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });
      setLoading(false);
    } else {
      window.history.back();
    }
  };

  useEffect(() => {
    loadCommercialEvaluationData();
    loadInitialPageData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rfxNr]);

  //print
  useEffect(() => {
    setprintCommercialEvalData(formInputs);
  }, [formInputs]);

  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: `Quotation-Comparison_${Math.floor(
      Math.random() * 1000000
    )}`,
  });
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <Loader isLoading={loading} className={"text-center"} />
        </Col>
        {!loading && (
          <Col xs={12} md={12} className="rightSide">
            <div className="rightSideInner PageCommonCSS">
              <h2 className="mainTitle">
                Commercial Evaluation for
                <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage m-1">
                  {formInputs?.rfxNr}
                </span>
                <span>
                  {formInputs?.rfxHeaderStatus === "Publish" ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "Cancelled" ? (
                    <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "Commercial Approved" ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "Commercial Open" ? (
                    <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "QTN Received" ? (
                    <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "Acknowledged" ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "Regret" ? (
                    <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : formInputs?.rfxHeaderStatus === "PO Created" ? (
                    <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                      {formInputs?.rfxHeaderStatus}
                    </span>
                  ) : (
                    formInputs?.rfxHeaderStatus
                  )}
                </span>
              </h2>
              <p className="subText">Commercial Evaluation Details</p>
              <hr />

              {/* Workflow Component */}
              <WorkflowApproveReject
                workflowData={workflow}
                formInputsData={formInputs}
              />

              {workflowConfig?.showInDetailPage &&
                formInputs?.workflowActionLogs?.length > 0 && (
                  <ShowHorizontalStatus
                    rowdatamodal={formInputs?.workflowActionLogs}
                  />
                )}

              <Col
                xs={8}
                md={{ span: 2, offset: 10 }}
                lg={{ span: 2, offset: 10 }}
                className="text-left mb-4"
                // onClick={createPo}
                onClick={handlePrint}
              >
                <button className="btnInfo">Print</button>
              </Col>
              <div style={{ display: "none" }}>
                <PrintCommercialEvaluation
                  ref={contentRef}
                  data={printCommercialEvalData}
                />
              </div>

              {/*RFQ Type  */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility1}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">RT</span>
                      </Col>
                      <Col xs={12} md={4} lg={4}>
                        <span className="headerTitle">RFQ Details </span>
                        <span className="subHeaderTitle">
                          RFQ Type Information
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${isCardVisible1 ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="RFQ ID"
                            name="rfxNr"
                            // placeholder=""
                            value={formInputs?.rfxNr || ""}
                            // onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Title"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs?.rfxTitle || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Description"
                            name="UnitPrice"
                            // placeholder=""
                            value={formInputs?.rfxDescription || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="RFQ Type"
                            name="rfxTypeDesc"
                            // placeholder=""
                            value={formInputs?.rfxTypeDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Product Type"
                            name="firstName"
                            placeholder=""
                            value={formInputs?.productTypeDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Buyer Responsible"
                            name="initiator"
                            placeholder=""
                            value={formInputs.initiator || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Buyer Contact"
                            name="buyerConact"
                            // placeholder=""
                            value={formInputs?.buyerConact || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Company Address"
                            name="billingAddress"
                            placeholder=""
                            value={formInputs?.billingAddress || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Delivery Address"
                            name="deliveryAddressCodeDesc"
                            placeholder=""
                            value={formInputs?.deliveryAddressCodeDesc || ""}
                            onChange={onInputChange}
                            disabled={true}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* Line Item 09*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible9
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility9}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">LI</span>
                      </Col>

                      <Col xs={4} md={8} lg={7}>
                        <span className="headerTitle">Line Item</span>
                        {/* <span className="subHeaderTitle">
                        Other Charges Table{" "}
                      </span> */}
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${isCardVisible9 ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body autoScroll">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <CompareLineItemTable
                            data={lineItemData}
                            sendDataToParent={handleItemData}
                            pageStatus={getDisabledStatus}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* 5 */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible5
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility5}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">SD</span>
                      </Col>
                      <Col xs={12} md={6} lg={7}>
                        <span className="headerTitle">Suppliers</span>
                        <span className="subHeaderTitle">
                          Selected Suppliers Details
                        </span>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${isCardVisible5 ? "visible" : ""
                      }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            // title=""
                            columns={suppliersColumns}
                            data={formInputs?.supplierList}
                            // progressPending={loading}
                            // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                            // pagination
                            // paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            selectableRows
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        )}
      </Row>
    </main>
  );
};

export default CommercialEvaluation;
